import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";

import App from "./App";

import NavigationProvider from "./providers/NavigationProvider";
import SelectedDateProvider from "./providers/SelectedDateProvider";
import BibleProvider from "./providers/BibleProvider";

import { unregister } from "./registerServiceWorker";

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <NavigationProvider>
    <SelectedDateProvider>
      <BibleProvider>
        <App />
      </BibleProvider>
    </SelectedDateProvider>
  </NavigationProvider>
);
unregister();
